import { cn } from "@/lib/utils";

/** Shared defaults for searchable selects, including menus and selected chips. */
export const SELECT_CLASS_NAMES = {
  valueContainer: () => "!px-3 !py-1.5 !gap-1",
  input: () => "!m-0 !p-0 !text-base !text-slate-900 sm:!text-sm",
  singleValue: ({ isDisabled = false }: { isDisabled?: boolean } = {}) =>
    cn(
      "!text-base sm:!text-sm",
      isDisabled ? "!text-slate-500" : "!text-slate-900",
    ),
  menu: () =>
    "!overflow-hidden !rounded-xl !border !border-slate-200 !bg-white !shadow-lg !shadow-slate-200/50",
  menuList: () => "!p-1.5",
  indicatorSeparator: () => "!bg-slate-200",
  placeholder: () => "!text-base !text-slate-500 sm:!text-sm",
  control: ({
    isFocused,
    isDisabled = false,
  }: {
    isFocused: boolean;
    isDisabled?: boolean;
  }) =>
    cn(
      "!min-h-12 !rounded-xl !border-slate-400 !bg-white !shadow-none transition-colors hover:!border-slate-500",
      isDisabled && "!border-slate-200 !bg-slate-50 hover:!border-slate-200",
      isFocused &&
        !isDisabled &&
        "!border-primary !ring-4 !ring-primary/10 hover:!border-primary",
    ),
  dropdownIndicator: ({ isDisabled = false }: { isDisabled?: boolean } = {}) =>
    isDisabled ? "!text-slate-300" : "!text-slate-500 hover:!text-slate-600",
  clearIndicator: () => "!text-slate-500 hover:!text-slate-600",
  option: ({
    isFocused,
    isSelected,
    isDisabled = false,
  }: {
    isFocused: boolean;
    isSelected: boolean;
    isDisabled?: boolean;
  }) =>
    cn(
      "!rounded-lg !px-3 !py-2.5 !text-sm !text-slate-700",
      isFocused && !isDisabled && "!bg-slate-50",
      isSelected && "!bg-primary/5 !font-semibold !text-primary",
      isDisabled && "!text-slate-400",
    ),
  multiValue: () => "!m-0 !overflow-hidden !rounded-lg !bg-primary/5",
  multiValueLabel: () =>
    "!rounded-none !border-0 !bg-primary/5 !py-1 !pl-2 !pr-1 !text-xs !font-semibold !text-primary",
  multiValueRemove: () =>
    "!rounded-none !border-0 !bg-primary/5 !px-1.5 !text-primary/70 hover:!bg-primary/10 hover:!text-primary",
};
